module.exports = __webpack_public_path__ + "static/media/undraw_thought_process_re_om58.1f2b3b64.svg";